// openMessageEditor.js
'use strict';
import { v4 } from 'uuid';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import getMessageData from '../selector/getMessageData.js';

import toggleModal from '../action/toggleModal.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';

import { PostDraftField, UploadJobType } from '../resource/uploadConstants.js';
import { Purpose as AssetPurpose } from '../resource/assetConstants.js';

/**
 * Open message editor
 * @kind action
 * @param {string} {messageId} - message id.
 * @return {Promise} Action promise.
 */
const openMessageEditor =
  ({ messageId } = {}) =>
  async (dispatch, getState) => {
    await dispatch(fetchMessageDetail({ id: messageId, forceRefetch: true }));
    const state = getState();
    const isStory = getMessageData(state, messageId, 'expiresAtUnix') != null;
    const scheduledAtUnix = getMessageData(state, messageId, 'scheduledAtUnix');
    const isPublished = getMessageData(state, messageId, 'isPublished');
    const categories = getMessageData(state, messageId, 'categories');
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['postDraft'],
        data: {
          [PostDraftField.ENTRY]: {
            value: isStory ? UploadJobType.STORY : UploadJobType.POST,
          },
          [PostDraftField.UPLOAD_JOB_ID]: {
            value: v4(),
          },
          [AssetPurpose.POST]: {
            assetIds: getMessageData(state, messageId, 'assetIds') || [],
          },
          [PostDraftField.CAPTION]: {
            value:
              getMessageData(state, messageId, 'originalCaptionText') || '',
          },
          [PostDraftField.TITLE]: {
            value: getMessageData(state, messageId, 'originalTitle') || '',
          },
          [PostDraftField.IS_AUP_CHECKED]: {
            value: true,
          },
          [PostDraftField.IS_AUP_CHECKBOX_EDITABLE]: {
            value: false,
          },
          [PostDraftField.CATEGORIES]: {
            value: categories || [],
          },
          [PostDraftField.UNLOCK_PRICE]: {
            value: getMessageData(state, messageId, 'unlockPrice'),
          },
          [PostDraftField.IS_UNLOCK_PRICE_EDITABLE]: {
            value: !isPublished,
          },
          [PostDraftField.IS_SCHEDULED_AT_UNIX_EDITABLE]: {
            value: !isPublished,
          },
          [PostDraftField.IS_SCHEDULE_ENABLED]: {
            value: !!scheduledAtUnix,
          },
          [PostDraftField.SCHEDULED_AT_UNIX]: {
            value: scheduledAtUnix,
          },
          [PostDraftField.MESSAGE_ID]: {
            value: messageId,
          },
          [PostDraftField.IS_EDIT_MODE]: {
            value: true,
          },
        },
      },
    });
    return dispatch(
      toggleModal({
        modalId: 'PostDraft',
        isOpen: true,
      })
    );
  };

export default openMessageEditor;
